import { useState } from "react";
import { Box, Button, FormControlLabel, FormGroup, Grid, Paper, Switch, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { getInvoiceDetails } from "./invoice_halper";
import Loading2 from "../frames/loading2";
import { getInvoiceFuel, getInvoicePrice } from "../billing/billing_halper";
import { dateUsaToInd, getCurrentDate, getOfficeMeta } from "../frames/common";
import '../billing/billing.css';
import './billing_print.css';
import { Helmet } from "react-helmet";
import { getClient } from "../client/client_halper";

const InvoicesView = ({ inv_num }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [invoice, setInvoice] = useState(null);
    const [outstanding, setOutstanding] = useState(0.00);
    const [showOutstanding, setShowOutstanding] = useState(true);
    const [showHSN, setShowHSN] = useState(false);
    const [showFuel, setShowFuel] = useState(true);
    const [showBreakdown, setShowBreakdown] = useState(true);
    const [showRate, setShowRate] = useState(false);
    const [logo, setLogo] = useState("/img/dtdc_logo.png");
    const params = useParams();
    const invoice_num = inv_num ?? params.invoice;

    if (invoice === null) {
        setInvoice([]);
        getInvoiceDetails(invoice_num).then((res) => {
            setInvoice(res);
            setIsLoading(false);
            return getClient(res.json_body.client.client_id, "billing");
        }).then((client) => {
            console.log(client);
            setOutstanding(client.balance);
            return getOfficeMeta();
        }).then((data) => {
            if (!!data.logo) setLogo(data.logo);

        }).catch((err) => {
            console.error(err);
        });
    }

    if (isLoading) return <Box sx={{ width: inv_num ? 500 : "auto", height: inv_num ? 400 : "auto" }}><Loading2 /></Box>
    return (
        <Paper elevation={0} className="invoice-view">
            <style>
                {
                    `
@media print {

    html,
    body {
        background-color: #FFF;
        padding: 0px;
        margin: 0px;
    }

    * {
        -webkit-print-color-adjust: exact !important; /* Chrome, Edge, Safari */
        print-color-adjust: exact !important;        /* Firefox */
        color-adjust: exact !important;              /* Legacy */
    }

    .invoice-view {
        min-height: 267mm;
    }

    .inv-head {
        page-break-before: auto;
        page-break-after: auto;
    }

    .inv-footer {
        page-break-before: auto;
        page-break-after: auto;
    }

    @page {
        size: A4;
        margin: 15mm 7mm;
    }

}`
                }
            </style>
            <Helmet>
                <title>{invoice_num}</title>
            </Helmet>
            <div className="inv-head">
                <Box align="center" sx={{ alignSelf: "center", alignContent: "center" }}>
                    <Typography variant="body2" className="invoice-title" style={{ letterSpacing: "5px", fontWeight: "bold" }}>Tax Invoice</Typography>
                    <Typography variant="h6" align="center">{invoice.json_body.office.name}</Typography>
                    <Typography variant="body2" align="center">{invoice.json_body.office.add_1}</Typography>
                    <Typography variant="body2" align="center">{invoice.json_body.office.add_2}</Typography>
                    {invoice.json_body.office.add_3 ? <Typography variant="body2" align="center">{invoice.json_body.office.add_3}</Typography> : ""}
                    {invoice.gst_num ? <Typography variant="body2" align="center" className="text">GSTIN: {invoice.gst_num}</Typography> : ""}
                </Box>
                <Box>
                    <Typography variant="caption" className="text">Customer ID:</Typography>
                    <Typography variant="subtitle1" className="text">{invoice.json_body.client.client_id}</Typography>
                </Box>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 4, sm: 4 }} >
                        <Box>
                            <Typography variant="caption">Bill To:</Typography>
                            <Typography variant="body2" className="text">{invoice.json_body.client.name}</Typography>
                            <Typography variant="body2" className="text">{invoice.json_body.client.billing_add_1}</Typography>
                            <Typography variant="body2" className="text">{invoice.json_body.client.billing_add_2}</Typography>
                            <Typography variant="body2" className="text">{invoice.json_body.client.billing_add_3}</Typography>
                            <Typography variant="body2" className="text">{invoice.json_body.client.billing_add_state} - {invoice.json_body.client.billing_add_zip}</Typography>
                            {invoice.json_body.client.gst_num ? <Typography variant="body2" className="text">GSTIN: {invoice.json_body.client.gst_num}</Typography> : ""}
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 4, sm: 4 }}>
                        <Box>
                            <Typography variant="caption">Shipping Address:</Typography>
                            <Typography variant="body2" className="text">{invoice.json_body.client.shipping_add_1}</Typography>
                            <Typography variant="body2" className="text">{invoice.json_body.client.shipping_add_2}</Typography>
                            <Typography variant="body2" className="text">{invoice.json_body.client.shipping_add_3}</Typography>
                            <Typography variant="body2" className="text">{invoice.json_body.client.shipping_add_state} - {invoice.json_body.client.shipping_add_zip}</Typography>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 4, sm: 4 }} sx={{ textAlign: "right" }}>
                        <Box pr={1}>
                            <Typography variant="caption">Summary</Typography>
                            <table width={"100%"}>
                                <tbody>
                                    <tr>
                                        <td sx={{ whiteSpace: "nowrap" }}><Typography variant="body2" className="text">Invoice Date:</Typography></td>
                                        <td sx={{ whiteSpace: "nowrap" }}><Typography variant="body2" className="text">{invoice.bill_date}</Typography></td>
                                    </tr>
                                    <tr>
                                        <td sx={{ whiteSpace: "nowrap" }}><Typography variant="body2" className="text">Invoice Number:</Typography></td>
                                        <td sx={{ whiteSpace: "nowrap" }}><Typography variant="body2" className="text">{invoice.bill_no}</Typography></td>
                                    </tr>
                                    <tr>
                                        <td sx={{ whiteSpace: "nowrap" }}><Typography variant="body2" className="text">Invoice Amount:</Typography></td>
                                        <td sx={{ whiteSpace: "nowrap" }}><Typography variant="body2" className="text">{invoice.bill_amount.toFixed(2)}</Typography></td>
                                    </tr>
                                    <tr>
                                        <td sx={{ whiteSpace: "nowrap" }}><Typography variant="body2" className="text">Payment:</Typography></td>
                                        <td sx={{ whiteSpace: "nowrap" }}><Typography variant="body2" className="text">{invoice.payment === 0 ? "Paid" : invoice.payment === invoice.bill_amount ? "Unpaid " : "Partial Payment"}</Typography></td>
                                    </tr>
                                </tbody>
                            </table>
                        </Box>
                    </Grid>
                </Grid>

                <table className="nowrap bill-priview">
                    <thead>
                        <tr>
                            <th className="sl-no"><Typography variant="body2">SL</Typography></th>
                            <th className="cn-date"><Typography variant="body2">Date</Typography></th>
                            <th colSpan={3}><Typography variant="body2">Description</Typography></th>
                            {showHSN && <th><Typography variant="body2">HSN</Typography></th>}
                            {/* <th><Typography variant="body2">Quantity</Typography></th> */}
                            {/* <th><Typography variant="body2">Rate</Typography></th> */}
                            {showBreakdown ? <>
                                {showRate && <th><Typography variant="body2">Rate</Typography></th>}
                                <th><Typography variant="body2">Price</Typography></th>
                                {showFuel && <th><Typography variant="body2">Fuel</Typography></th>}
                                {/* <th><Typography variant="body2">Taxable</Typography></th> */}
                                <th><Typography variant="body2">GST</Typography></th>
                                <th><Typography variant="body2">Total</Typography></th>
                            </> :
                                <th><Typography variant="body2">Price</Typography></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {invoice.json_body.particular.map((item, index) =>
                            <tr key={index}>
                                <td className="sl-no">
                                    <Typography variant="body2" className="text">{item.sl_no}</Typography>
                                </td>
                                <td className="cn-date">
                                    <Typography variant="body2" className="text">{item.date}</Typography>
                                </td>
                                <td colSpan={item.hsn === 996812 ? 0 : 3} style={{ lineHeight: "14px" }}>
                                    <Typography variant="body2" className="text"><strong>{item.title}</strong></Typography>
                                    <Typography variant="caption" className="text">{item.description}</Typography>
                                </td>
                                {item.hsn === 996812 ?
                                    <>
                                        <td>
                                            <Typography variant="body2" className="text">{item.destination}</Typography>
                                        </td>
                                        <td align="right">
                                            <Typography variant="body2" className="text">{item.weight >= 1000 ? (item.weight / 1000).toFixed(3) + " Kg" : item.weight + " Grm"}</Typography>
                                        </td>
                                    </>
                                    :
                                    ""
                                }
                                {showHSN && <td>
                                    <Typography variant="body2" className="text">{item.hsn}</Typography>
                                </td>}
                                {/* <td align="right">
                                    <Typography variant="body2" className="text">{item.quantity}</Typography>
                                </td> */}
                                {/* <td align="right">
                                    <Typography variant="body2" className="text">{item.rate.toFixed(2)}</Typography>
                                    {item.other !== 0 ? Math.abs(item.other) < 10 ?
                                        <Typography variant="caption" className="text">Adj: {item.other.toFixed(2)}</Typography> :
                                        item.other < 0 ? <Typography variant="caption" className="text">Disc: {item.other.toFixed(2)}</Typography> :
                                            <Typography variant="caption" className="text">Oth: {item.other.toFixed(2)}</Typography> : ""}
                                </td> */}
                                {showBreakdown ? <>
                                    {showRate && <td align="right">
                                        <Typography variant="body2">{item.rate.toFixed(2)}</Typography>
                                        {item.other !== 0 ? Math.abs(item.other) < 10 ?
                                            <Typography variant="caption">Adj: {item.other.toFixed(2)}</Typography> :
                                            item.other < 0 ? <Typography variant="caption">Disc: {item.other.toFixed(2)}</Typography> :
                                                <Typography variant="caption">Oth: {item.other.toFixed(2)}</Typography> : ""}
                                    </td>}
                                    {showFuel ? <>
                                        <td align="right">
                                            <Typography variant="body2" className="text">{item.price.toFixed(2)}</Typography>
                                        </td>
                                        <td align="right">
                                            <Typography variant="body2" className="text">{item.fuel.toFixed(2)}</Typography>
                                        </td>
                                    </> :
                                        <td align="right">
                                            <Typography variant="body2" className="text">{(item.price + item.fuel).toFixed(2)}</Typography>
                                        </td>
                                    }
                                    <td align="right">
                                        <Typography variant="body2" className="text">{item.gst.toFixed(2)}</Typography>
                                    </td>
                                    <td align="right">
                                        <Typography variant="body2" className="text">{(item.price + item.fuel + item.gst).toFixed(2)}</Typography>
                                    </td>
                                </> :
                                    <td align="right">
                                        <Typography variant="body2" className="text">{(item.price + item.fuel + item.gst).toFixed(2)}</Typography>
                                    </td>
                                }
                            </tr>
                        )}
                    </tbody>
                </table>
                <table className="nowrap bill-priview summary-preview" style={{ margin: "5px 0 0 0" }}>
                    <tbody>
                        <tr>
                            <td align="right">
                                <Typography variant="body2" className="text">Service Value</Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2" className="text">₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2" className="text">{getInvoicePrice(invoice.json_body.particular).toFixed(2)}</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">
                                <Typography variant="body2" className="text">Fuel Charge</Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2" className="text">₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2" className="text">{getInvoiceFuel(invoice.json_body.particular).toFixed(2)}</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">
                                <Typography variant="body2" className="text">Taxable Value</Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2" className="text">₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2" className="text">{invoice.taxable_amount.toFixed(2)}</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">
                                <Typography variant="body2" className="text">
                                    Goods and Services Tax (
                                    {
                                        (!invoice.json_body.client.gst_num || invoice.json_body.client.gst_num.substring(0, 2) === invoice.gst_num.substring(0, 2))
                                            ?
                                            "CGST + SGST"
                                            :
                                            "IGST"
                                    }
                                    )
                                </Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2" className="text">₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2" className="text">{(invoice.bill_amount - invoice.taxable_amount).toFixed(2)}</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">
                                <Typography variant="body2" fontWeight={"bold"} className="text">Total Payable</Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2" fontWeight={"bold"} className="text">₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2" fontWeight={"bold"} className="text">{invoice.bill_amount.toFixed(2)}</Typography>
                            </td>
                        </tr>
                        {showOutstanding &&
                            <tr>
                                <td align="right">
                                    <Typography variant="body2" fontWeight={"bold"} className="text">Total Outstanding Balance <sup>*</sup></Typography>
                                </td>
                                <td className="rupee"><Typography variant="body2" fontWeight={"bold"} className="text">₹</Typography></td>
                                <td align="right" className="amount">
                                    <Typography variant="body2" fontWeight={"bold"} className="text">{outstanding.toFixed(2)}</Typography>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div className="inv-footer">
                <div>
                    <Typography variant="caption" className="text">
                        * As of {dateUsaToInd(getCurrentDate())}. Latest payment may take 1-3 business days to reflect.
                    </Typography>
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td>
                                    <Box sx={{ mt: 1 }}>
                                        <img src={logo} width={"200px"} alt="Invoice logo" /><br />
                                        <Typography variant="body2" color="textDisabled" fontSize={12} className="text">
                                            To go paperless and reduce your carbon footprint, request a free online invoice copy. Extra hardcopy fee ₹10/page<br />
                                            Each page in invoice contributes 5g of carbon footprint to the environment.<br />
                                            Thank you for choosing our services. For queries, contact gamaria.pat@fr.dtdc.com
                                        </Typography>
                                    </Box>
                                </td>
                                <td style={{ width: "170px", textAlign: "right" }}>
                                    <img src={"https://api.sixpetal.com/qrcode/" + btoa("https://crm.redmorus.com/invoices/public-view/" + invoice.bill_no)} alt="QR code" width={100} />
                                    <br />
                                    <Typography variant="caption" className="text">Invoice and payment details</Typography>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="print-btn">
                    <FormGroup className="print-btn" sx={{ display: "inline-block", ml: 2 }}>
                        <FormControlLabel control={<Switch defaultChecked style={{ textTransform: "unset" }} onClick={() => { setShowOutstanding(!showOutstanding) }} />} label={showOutstanding ? "Show Outstanding Balance" : "Hide Outstanding Balance"} />
                    </FormGroup>
                    <FormGroup className="print-btn" sx={{ display: "inline-block", ml: 2 }}>
                        <FormControlLabel control={<Switch defaultChecked style={{ textTransform: "unset" }} onClick={() => { setShowFuel(!showFuel) }} />} label={showFuel ? "Show Fuel Charges" : "Hide Fuel Charges"} />
                    </FormGroup>
                    <FormGroup className="print-btn" sx={{ display: "inline-block", ml: 2 }}>
                        <FormControlLabel control={<Switch defaultChecked style={{ textTransform: "unset" }} onClick={() => { setShowBreakdown(!showBreakdown) }} />} label={showBreakdown ? "Show Price Breakdown" : "Hide Price Breakdown"} />
                    </FormGroup>
                    <FormGroup className="print-btn" sx={{ display: "inline-block", ml: 2 }}>
                        <FormControlLabel control={<Switch defaultChecked={false} style={{ textTransform: "unset" }} onClick={() => { setShowHSN(!showHSN) }} />} label={showHSN ? "Show HSN/SAC Code" : "Hide HSN/SAC Code"} />
                    </FormGroup>
                    <FormGroup className="print-btn" sx={{ display: "inline-block", ml: 2 }}>
                        <FormControlLabel control={<Switch defaultChecked={false} style={{ textTransform: "unset" }} onClick={() => { setShowRate(!showRate) }} />} label={showRate ? "Show Rate" : "Hide Rate"} />
                    </FormGroup>
                    <Button variant="outlined" color="success" fullWidth onClick={() => { window.print(); }}>Print</Button>
                </div>
            </div>
        </Paper>
    );
};

export default InvoicesView;
